export default "__VITE_ASSET__C_Prqo0m__"